import React from 'react';
import './Sneezeguard.styl';

export const Sneezeguard = () => <div className="sneezeguard" />;
